import { render, staticRenderFns } from "./Registrasi.vue?vue&type=template&id=7474af95&scoped=true&"
import script from "./Registrasi.vue?vue&type=script&lang=js&"
export * from "./Registrasi.vue?vue&type=script&lang=js&"
import style0 from "./Registrasi.vue?vue&type=style&index=0&id=7474af95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7474af95",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VContainer,VForm,VSelect,VTextField})
